import Request from "../lib/request";
import {
  ACCOUNT_TITLES_API,
  DEFAULT_ACCOUNT_TITLES_API,
  IMPORTS_API,
  PROJECTS_API,
  TYPES_API,
  UPDATE_ACCOUNT_TITLE_LEVEL
} from "../constants/api";
import { PROJECT_ID } from "../constants/storageKeys";
import { PAGE } from "../constants/filters";

const baseUrl = process.env.REACT_APP_API_URL;

export const getList = page_number => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${ACCOUNT_TITLES_API}`,
    params: { [PAGE]: page_number },
    needToken: true
  });
};
export const show = id => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${ACCOUNT_TITLES_API}/${id}`,
    needToken: true
  });
};

export const remove = id => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "delete",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${ACCOUNT_TITLES_API}/${id}`,
    needToken: true
  });
};

export const store = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${ACCOUNT_TITLES_API}`,
    needToken: true,
    data: data
  });
};

export const getTypesForDefaultsList = () => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${DEFAULT_ACCOUNT_TITLES_API}/${TYPES_API}`,
    needToken: true
  });
};

export const getDefaultsList = type => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${DEFAULT_ACCOUNT_TITLES_API}${
      type ? "?type=" + type : ""
    }`,
    needToken: true
  });
};

export const storeDefault = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${DEFAULT_ACCOUNT_TITLES_API}`,
    needToken: true,
    data: data
  });
};

export const update = (id, data) => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${ACCOUNT_TITLES_API}/${id}`,
    needToken: true,
    data: data
  });
};

export const importFile = data => {
  let formData = new FormData();
  formData.append("file", data.file);
  data.team_ids.forEach(teamId => formData.append("team_ids[]", teamId));
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${IMPORTS_API}/${ACCOUNT_TITLES_API}`,
    needToken: true,
    headers: {
      "Content-Type": "multipart/forms-data"
    },
    data: formData
  });
};

export const updateAccountTitleLevel = data => {
  const projectId = localStorage.getItem(PROJECT_ID);
  return Request({
    method: "put",
    url: `${baseUrl}/${PROJECTS_API}/${projectId}/${UPDATE_ACCOUNT_TITLE_LEVEL}`,
    needToken: true,
    data: data
  });
};
